import * as React from 'react'

export const AppconfigContext = React.createContext({})
